import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/payrollOfSelf/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/payrollOfSelf/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/payrollOfSelf/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/payrollOfSelf/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/payrollOfSelf/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/payrollOfSelf/delete',
      method: 'delete',
      params: data
    })
  }
}
